export type TenantType = "external" | "internal";

export interface TenantConfig {
    clientId: string;
    tenantId: string;
    authority: string;
    name: string;
}

const redirectUri = window.location.origin;

const tenantConfigs: Record<TenantType, TenantConfig> = {
    external: {
        clientId: import.meta.env.VITE_AZURE_AD_EXTERNAL_CLIENT_ID ?? "",
        tenantId: import.meta.env.VITE_AZURE_AD_EXTERNAL_TENANT_ID ?? "",
        authority:
            "https://c7523826-fed7-45c7-a6af-9daa538f8a9b.ciamlogin.com/c7523826-fed7-45c7-a6af-9daa538f8a9b/v2.0",
        name: "External",
    },
    internal: {
        clientId: import.meta.env.VITE_AZURE_AD_INTERNAL_CLIENT_ID ?? "",
        tenantId: import.meta.env.VITE_AZURE_AD_INTERNAL_TENANT_ID ?? "",
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_INTERNAL_TENANT_ID}`,
        name: "Internal",
    },
};

if (import.meta.env.MODE !== "production") {
    Object.entries(tenantConfigs).forEach(([key, config]) => {
        if (!config.clientId || !config.tenantId) {
            console.warn(
                `Missing Azure AD configuration for ${key}: clientId=${config.clientId}, tenantId=${config.tenantId}`
            );
        }
    });
}

export const getTenantConfig = (tenant: TenantType): TenantConfig => {
    return tenantConfigs[tenant];
};

export { redirectUri, tenantConfigs };
